// extracted by mini-css-extract-plugin
export var label = "_cs-1";
export var reminder = "_cs-0";